import type { StructuredSearchStore } from "@/components/StructuredSearch/stores/structured-search/structured-search-store";
import { REQUESTS_TABLE_URL_NAMESPACE } from "@/components/StructuredSearch/hooks/structuredSearchUrlNamespaces";
import { applyStructuredSearchStateToSearchParams } from "@/components/StructuredSearch/hooks/useStructuredSearchURLSync";
import {
  appendReviewLogsReturnTo,
  buildReviewLogsReturnTo,
  stripReviewLogsDrawerIntent,
} from "@/utils/requestLogUrlParams";

/** Builds request-logs table search from sidebar filters, preserving an independent return URL. */
export const buildSidebarExploreInTableSearch = ({
  sidebarStore,
  returnPathname,
  returnSearch,
}: {
  sidebarStore: StructuredSearchStore;
  returnPathname: string;
  returnSearch: string;
}): string => {
  const tableParams = applyStructuredSearchStateToSearchParams(
    new URLSearchParams(),
    {
      filters: sidebarStore.filters,
      dateRange: sidebarStore.dateRange,
      q: sidebarStore.q,
      pageIndex: sidebarStore.pageIndex,
      pageSize: sidebarStore.pageSize,
      sorting: sidebarStore.sorting,
    },
    { namespace: REQUESTS_TABLE_URL_NAMESPACE },
  );
  const tableSearch = tableParams.toString();
  const returnTo = buildReviewLogsReturnTo(
    returnPathname,
    stripReviewLogsDrawerIntent(returnSearch),
  );
  return appendReviewLogsReturnTo(tableSearch ? `?${tableSearch}` : "", returnTo);
};
